export enum CartStatus {
  SHOPPING = "Shopping",
  COMPLETE = "Complete",
  CHECKOUT = "Checkout",
}
